
  export default {
    props: {
      instructions: String
    },
    data() {
      window.wf ??= {};
      let d = window.wf.ProductComparison;
      d.products ??= {};
      d.checkedProducts ??= [];
      return d;
    },
    methods: {
      incrementCount() {
        this.count++;
      },
      btnClass(colorName, isOutline) {
        if (isOutline) {
          return "btn btn-outline-" + colorName;
        }
        return "btn btn-" + colorName;
      }
    },
    computed: {
      visibleProducts() {
        return this.products.filter(el => this.checkedProducts.includes(el.codename));
      },
      maxFeatures() {
        // return the maximun number of features for visible products
        if (this.visibleProducts == null || this.visibleProducts.length === 0) {
          return 0;
        }
        let maxFeatures = 0;
        let prodFeatures = 0;
        let i = 0;
        for (i = 0; i < this.visibleProducts.length; i++) {
          if (this.visibleProducts[i].features != null) {
            prodFeatures = this.visibleProducts[i].features.length;
          }
          maxFeatures = Math.max(maxFeatures, prodFeatures);
        }
        return maxFeatures;

      }
    }
  }
